import { jsx as _jsx } from "react/jsx-runtime";
import { Input } from '@dossierhq/design';
export function NumberFieldDisplay({ value }) {
    return _jsx(Input, { value: value ?? '', readOnly: true });
}
//# sourceMappingURL=NumberFieldDisplay.js.map